/**
 * 用户管理模块 - 扩展设计规范
 * 基于租户管理的 DesignTokens，扩展用户管理特定的样式
 */

// 引入租户管理的设计系统
import { DesignTokens as BaseDesignTokens } from '../TenantManagement/DesignTokens';

// 扩展用户管理特定的 tokens
export const UserDesignTokens = {
  ...BaseDesignTokens,

  // 用户状态颜色
  userStatus: {
    active: BaseDesignTokens.colors.success,
    disabled: BaseDesignTokens.colors.gray6,
  },

  // 密码强度颜色
  passwordStrength: {
    weak: BaseDesignTokens.colors.error,
    medium: BaseDesignTokens.colors.warning,
    strong: BaseDesignTokens.colors.success,
  },

  // 登录状态颜色
  loginStatus: {
    success: BaseDesignTokens.colors.success,
    failed: BaseDesignTokens.colors.error,
  },
};

// 导出基础的 DesignTokens 供兼容使用
export const DesignTokens = BaseDesignTokens;

// 工具函数：根据密码强度获取颜色
export const getPasswordStrengthColor = (
  strength: 'weak' | 'medium' | 'strong'
): string => {
  return UserDesignTokens.passwordStrength[strength];
};

// 工具函数：根据用户状态获取颜色
export const getUserStatusColor = (status: 'active' | 'disabled'): string => {
  return UserDesignTokens.userStatus[status];
};

// 工具函数：根据登录状态获取颜色
export const getLoginStatusColor = (status: 'success' | 'failed'): string => {
  return UserDesignTokens.loginStatus[status];
};
